import wicketRoutes from '../../../routes-wicket';
import { prependAppPath } from '../../services/Url';

export const prependAppPathToEmbbeddedWicketPages = (page: string) => {
    const path = page.startsWith('/')
        ? page
        : new URL(page, window.location.href).href.replace(window.location.origin, '');
    return wicketRoutes.some(route => path.startsWith(route)) ? prependAppPath(path) : path;
};
